import {message} from "antd";
import {useNavigate} from "react-router-dom";
import {useDigitalProductMutations} from "../../../../features/digital-products";

export function useDeleteProductHook(productId: number) {
  const {deleteProductAsync} = useDigitalProductMutations();
  const navigate = useNavigate();
  function deleteProduct(): Promise<unknown> {
    return new Promise((resolve) => {
      resolve(
        deleteProductAsync(productId, {
          onSuccess() {
            message.success("The selected product has been deleted successfully!");
            navigate("/products");
          },
          onError(error) {
            message.error(
              error.response?.data?.message || error.message || "Failed to delete product"
            );
          },
        })
      );
    }).catch(() => {});
  }

  return {
    deleteProduct,
  };
}
